import React from "react";
import { Col, Row } from "antd";
import Style from "./index.module.scss";

export interface Props {
    text: string;
    children: React.ReactChild;
    required?: boolean;
    colSpan?: number[];
}
const Index = ({ text, required, children, colSpan = [9, 8] }: Props) => {
    return (
        <Row>
            <Col className={Style.left} span={colSpan[0]}>
                <div className={Style.label}>
                    {required && <i className={Style.required}>*</i>}
                    {text}：
                </div>
            </Col>
            <Col className={Style.right} span={colSpan[1]}>
                {children}
            </Col>
        </Row>
    );
};

export default Index;
